/* 生成config常量 */
import browserCheck from '@/utils/checkBrowser'

// loginUrl
let browserType = browserCheck.browser
let loginTarget = () => {
  let type = ''
  switch (browserType) {
    case 'wechat':
      type = '/index'
      break
    default:
      type = '/phone'
      break
  }
  return type
}
export const loginUrl = process.env.VUE_APP_LOGIN_ROOT + loginTarget()
